import { ICoords } from "@dhx/ts-diagram";
import { el } from "@dhx/ts-common/dom";

export class SelectionBox {
	public end: ICoords;

	constructor(public start: ICoords) {}
	render() {
		const width = Math.abs(this.start.$rx - this.end.$rx);
		const height = Math.abs(this.start.$ry - this.end.$ry);
		const left = this.start.$rx < this.end.$rx ? this.start.$rx : this.end.$rx;
		const top = this.start.$ry < this.end.$ry ? this.start.$ry : this.end.$ry;
		return el(".dhx_selection_box", {
			dhx_id: "dhx_selection_box",
			style: {
				left,
				top,
				width: this.start.$rx < this.end.$rx ? width : this.start.$rx - left,
				height: this.start.$ry < this.end.$ry ? height : this.start.$ry - top,
			},
		});
	}
	isValid() {
		return (
			this.start &&
			this.end &&
			Math.abs(this.start.$rx - this.end.$rx) > 10 &&
			Math.abs(this.start.$ry - this.end.$ry) > 10
		);
	}
}
